<template>
  <div class="sa-card sa-card-border sa-card-noshadow">
    <avtar :editBoolean="editBoolean" @editFlag="pflag =$event" @imgEvent="imgUrl =$event" />
    <ValidationObserver ref="form" v-slot="{ handleSubmit}">
      <div class="sa-tit-heading sa-h-sm-up">Language Spoken</div>
    <form @submit.prevent>
      <div class="sa-row">
        <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4">
          <ValidationProvider class="sa-form-group" rules="required" name="Selected Language" tag="div" v-slot="{errors}">
            <label>Selected Language</label>
            <!-- <i class="icon-down-arrow sa-form-icon"></i> -->
            <v-select
              :options="selectlanguages" name="Selected Language"
              class="sa-multiple-tag"
              multiple id="selectedLanguage"
              v-model="langReq.language.known_lang"
              :disabled="!pflag"
              :class="!pflag?'sa-disabled':''"
            ><span slot="no-options">No data</span></v-select>
            <span class="sa-val-err">{{errors[0]}}</span>
          </ValidationProvider>
        </div>
        </div>
        <div v-if="pflag" class="sa-text-right">
          <button class="sa-btn sa-btn-primary sa-btn-block-xs" @click="handleSubmit(updateProfile)">
            Save
          </button>
        </div>
    </form>
      <div class="sa-dialog-white" v-if="loader">
        <img src="../../assets/img/loader.svg" alt="loader" class="sa-loader" />
      </div>
    </ValidationObserver>
  </div>
</template>
<script>
import AvtarVue from "../common/Avtar.vue";
import { pro_url } from "../../../config/endpoints";
export default {
  props: ["pInfo"],
  components: {
    avtar: AvtarVue,
  },
  data() {
    return {
      loader: false,
      langReq: {
        mtype: "language",
        language: {
          img: "",
          known_lang: ["Arabic", "English"],
        },
      },

      imgUrl: null,
      editBoolean: false,
      pflag: false,
      img: "",
      selectlanguages: ["English", "Arabic"],
    };
  },
  created() {
    this.langReq.language = this.pInfo.language;
  },
  methods: {
    setImg(uimg) {
      let _self = this;
      _self.img = uimg;
    },
    updateProfile() {
      let _self = this;
      if (_self.imgUrl) {
        _self.langReq.language.img = _self.imgUrl;
        let userInfo = JSON.parse(_self.$localStorage.get("userdata")) || {};
        userInfo.img = _self.imgUrl;
        _self.$localStorage.set(
          "userdata",
          JSON.stringify(userInfo),
          60 * 60 * 2 + 55
        );
      }
      _self.loader = true;
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/addProfile`,
          body: _self.langReq,
        })
        .then((response) => {
          if (response && response.status === 1000) {
            _self.$parent.getUserData()
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Language spoken updated successfully",
              class: "sa-a-success",
            });
          } else if (response && response.status == "2001") {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Session Expired. Please login again",
              class: "sa-a-danger",
            });
            _self.$localStorage.remove("token");
            _self.$localStorage.remove("userdata");
            _self.$router.push({ path: "/" });
          } else {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Something went wrong",
              class: "sa-a-danger",
            });
          }
          _self.loader = false;
        })
        .catch((e) => {
          _self.$store.dispatch("SET_ALERTMESSAGE", {
            msg: "Something went wrong",
            class: "sa-a-danger",
          });
          _self.loader = false;
        });
    },
  },
  watch: {
    pflag: {
      immediate: true,
      deep: true,
      handler() {
        let _self = this;
        _self.editBoolean = _self.pflag;
      },
    },
  },
};
</script>
